module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card schadeprocess"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "error-process"
    }
  }), _vm._v(" "), (!_vm.pageDataLoaded) ? _c('loader-component') : _vm._e(), _vm._v(" "), (_vm.pageDataLoaded) ? _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "process-menu messages"
  }, [_c('div', {
    class: [{
      'mobile-hide': _vm.polissen.length > 3
    }, {
      'hide': _vm.polissen.length === 1
    }, {
      'desktop-hide': _vm.polissen.length > 5
    }]
  }, [_c('ul', {
    staticClass: "nav nav-tabs flex-container"
  }, _vm._l((_vm.polissen), function(polis, index) {
    return _c('li', {
      key: polis.polisnummer,
      staticClass: "nav-item",
      on: {
        "click": function($event) {
          _vm.currentTab = index
        }
      }
    }, [_c('a', {
      class: ['nav-link', {
        active: _vm.currentTab === index
      }]
    }, [_vm._v("\r\n\t\t\t\t\t\t\t" + _vm._s(polis.produktNaam)), _c('br'), _vm._v(" "), (polis.kenteken) ? _c('span', [_vm._v(_vm._s(polis.kenteken))]) : _vm._e(), _vm._v(" "), (polis.produktTypeNaam == 'woonhuis' || polis.produktTypeNaam == 'inboedel') ? _c('span', [_vm._v(_vm._s(polis.straat))]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "selectbox-menu",
    class: [{
      'desktop-hide': _vm.polissen.length < 6
    }, {
      'mobile-hide': _vm.polissen.length < 4
    }, {
      'hide': _vm.polissen.length === 1
    }]
  }, [_c('span', [_vm._v("Selecteer een verzekering:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tab_selector"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectedTab]
    }
  }, _vm._l((_vm.polissen), function(polis, index) {
    return _c('option', {
      key: index,
      domProps: {
        "selected": index === 0,
        "value": index
      }
    }, [_vm._v("\r\n\t\t\t\t\t\t" + _vm._s(polis.produktNaam) + "\r\n\t\t\t\t\t"), (polis.kenteken) ? _c('span', [_vm._v("- " + _vm._s(polis.kenteken))]) : _vm._e(), _vm._v(" "), (polis.produktTypeNaam == 'woonhuis' || polis.produktTypeNaam == 'inboedel') ? _c('span', [_vm._v("- " + _vm._s(polis.straat))]) : _vm._e()])
  }), 0), _vm._v(" "), _c('br')]), _vm._v(" "), _c(_vm.currentTabComponent, {
    tag: "component",
    attrs: {
      "produktnaam": _vm.currentTabName,
      "schademeldenurl": _vm.currentSchadeUrl,
      "ctx": _vm.ctx
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_c('span', [_vm._v("\t\t\t\r\n\t\t\t\tHoe verloopt het schadeproces?\r\n\t\t\t")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ce74923"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/schade/schadeproces.vue
// module id = 97
// module chunks = 0